import * as _ from 'lodash';
import validate from 'validate.js';
export default class StringUtils {
    static isBlank(text) {
        if (text == null || !_.isString(text)) {
            return true;
        }
        const textString = text;
        return _.isEmpty(textString.trim());
    }
    static isNotBlank(text) {
        return !this.isBlank(text);
    }
    static isEmail(text) {
        if (StringUtils.isBlank(text)) {
            return false;
        }
        const valid = validate.validate({ from: text }, { from: { email: true } });
        return valid === undefined;
    }
}
// String.replacei = String.prototype.replacei = function (rep, rby) {
//   var pos = this.toLowerCase().indexOf(rep.toLowerCase());
//   return pos == -1 ? this : this.substr(0, pos) + rby + this.substr(pos + rep.length);
// };
